export default __webpack_public_path__ + "static/media/ASSETS-stock.06f8a2d8.png";